import { getSwapChainListApi } from '@/services/swap';
import { useRequest } from 'ahooks';
import { useToast } from '@web3/base-hooks';
import { createGlobalState } from 'react-use';

const useSwapChainListState = createGlobalState([]);
export const useSwapChainList = () => {
  const { toastWarn } = useToast();
  const [swapChainList, setSwapChainList] = useSwapChainListState();
  const { refresh: refreshSwapChainList } = useRequest(
    async () => {
      if (swapChainList.length) return;
      const { success, result, message } = await getSwapChainListApi();
      if (!success) {
        toastWarn(message);
        return setSwapChainList([]);
      }
      setSwapChainList(result.sort((a, b) => a.order - b.order));
    },
    {
      refreshDeps: [swapChainList],
    }
  );

  const getBaseTokenName = (chainId: number) => {
    const chain = swapChainList.find((chain) => chain.chainId === chainId);
    return chain?.baseToken;
  };

  return {
    swapChainList,
    refreshSwapChainList,
    getBaseTokenName,
  };
};
